import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { RidangoReduxAction } from '@ridango/core';
import { Observable } from 'rxjs';
import { map, reduce } from 'rxjs/operators';
import { SubscriptionService } from '../subscription.service';
import { SubscriptionActions } from './subscription.actions';

import { SubscriptionState } from './subscription.store';

@Injectable()
export class SubscriptionFacade {
    // loaded$ = this.store.pipe( select( ThemingSelectors.getThemingLoaded ) );
    // loadedThemeName$ = this.store.pipe( select( ThemingSelectors.getThemeName ) );
    all$: Observable<any>;
    loaded$: Observable<boolean>;
    constructor(
        private ngRedux: NgRedux<SubscriptionState>,
        private service: SubscriptionService,
        private actions: SubscriptionActions
    ) {

        // we can map the state to whichever state we feel we need
        // eg: currenlty the consumer of 'all$' have no real need for array of ids
        // hence mapping ids=>objects
        this.all$ = this.ngRedux.select( [ 'subscriptions' ] ).pipe( map( ( state: SubscriptionState ) => {
            return state.allIds.map( sid => state.byId[ sid ] );
        } ) );

        this.loaded$ = this.ngRedux.select( [ 'subscriptions', 'loaded' ] );
    }

    dispatch ( action: RidangoReduxAction ) {
        this.ngRedux.dispatch( action );
    }

    loadSubscriptions () {
        // this should be in ngrx effects
        return this.service.fetchSubscriptions().pipe(
            reduce( ( acc, value: any[] ) => {
                return {
                    allIds: value.map( s => s.id ),
                    byId: value.reduce( ( a, v ) => {
                        return { ...a, [ v.id ]: v };
                    }, {} )
                };
            }, {} )
        ).subscribe(
            d => {
                this.dispatch( this.actions.setSubscriptions( d ) );
            },
            e => {
                // this.dispatch( this.actions.subscriptionsFetchFailed( e ) );
                console.log( 'error', e );
            }
        );
    }

    deleteSubscription ( subscription ) {
        this.dispatch( this.actions.deleteSubscripton() );
        return this.service.deleteSubscription( subscription ).subscribe(
            d => {
                this.dispatch( this.actions.deleteSubscriptionSuccess( subscription ) );
            },
            e => {
                this.dispatch( this.actions.deleteSubscriptionError( e ) );
            }
        )
    }
}
